import Vue from 'vue'
import VueMoment from 'vue-moment'
import VeeValidate from 'vee-validate'
import Notifications from 'vue-notification'
import VueNumeric from 'vue-numeric'
import VueBreadcrumbs from 'vue-breadcrumbs'
import Lang from 'vuejs-localization'
import _ from 'lodash'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import router from './router'
import App from './App.vue'
import api from '@/utils/Webservice'
import shareService from '@/utils/ShareService'
//import '../public/js/sorting.js'
import './filters'
import './scss/index.scss'

import moment from 'moment'
require('moment/locale/en-gb')
require('moment/locale/id')

// window.$ = window.jQuery = require('jquery')
const BASE_URL = 'http://192.168.2.39:8000'
Vue.BASE_URL = BASE_URL
Vue.prototype.$api = api
Vue.prototype.$shareService = shareService
Vue.prototype.$_ = _
Vue.prototype.imageBaseUrl = process.env.VUE_APP_IMAGE_BASE_URL;
Vue.prototype.BASE_URL = BASE_URL
Vue.prototype.$flowFilter = (array, substr) => {
  return array.filter(o => o.name.toLowerCase().includes(substr.toLowerCase()))
}

Vue.config.productionTip = false

Lang.requireAll(require.context('../lang', true, /\.js$/))
Vue.use(Lang)
Vue.use(VeeValidate, {
  classes: true
})
Vue.use(VueNumeric)
Vue.use(Notifications)
Vue.use(VueBreadcrumbs)
Vue.use(VueMoment, {
  moment
})
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(VueReCaptcha, {
    siteKey: '6LcmVIEbAAAAAJSUR_wTgn61FAcQAYFp4cslTRTK',
    loaderOptions: {
      autoHideBadge: true
    }
  }
)

Vue.filter('bool2StringFormat', function (value) {
  if(typeof  value === "boolean"){
    return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
  }
  return value
});


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
